<clr-vertical-nav
  [clrVerticalNavCollapsible]="true"
  [clrVerticalNavCollapsed]="false"
  class="nav-trigger--bottom"
  >
  @for (menuitem of menuItems$ | async; track menuitem) {
    <!--If is a single link-->
    @if (menuitem.type === 'link') {
      <a
        clrVerticalNavLink
        [routerLink]="[menuitem.path]"
        routerLinkActive="active"
        >
        <cds-icon [shape]="menuitem.icontype" clrVerticalNavIcon></cds-icon>
        {{ menuitem.title }}
      </a>
    }
    <!--If it have a submenu-->
    @if (menuitem.type === 'sub') {
      <clr-vertical-nav-group routerLinkActive="active">
        <cds-icon [shape]="menuitem.icontype" clrVerticalNavIcon></cds-icon>
        {{ menuitem.title }}
        @for (childitem of menuitem.children; track childitem) {
          <clr-vertical-nav-group-children>
            <a
              clrVerticalNavLink
              [routerLink]="menuitem.path + '/' + childitem.path"
              routerLinkActive="active"
              >{{ childitem.title }}</a
              >
            </clr-vertical-nav-group-children>
          }
        </clr-vertical-nav-group>
      }
    }
  </clr-vertical-nav>
